export function combineResourceLists(resourceLists) {
  if (!resourceLists) {
    return;
  }
  // if empty
  if (resourceLists.length === 0) {
    return;
  }

  let combinedResourceList = [];

  // for each list check if the clientName is the same.
  // if it is then add the project to the list and combine the materials
  // if it is not then add the list to the combinedResourceList

  resourceLists.forEach((resourceList) => {
    let clientIndex = combinedResourceList.findIndex(
      (list) => list.clientName === resourceList.clientName
    );

    // if client is not in combinedResourceList, add it
    if (clientIndex === -1) {
      combinedResourceList.push(resourceList);
    } else {
      // if client is in combinedResourceList, add to it
      combinedResourceList[clientIndex].materials.push(
        ...resourceList.materials
      );

      // combine plants
      combinedResourceList[clientIndex].plants.push(...resourceList.plants);
    }
  });

  return combinedResourceList;
}
